// SAT talebinin durum ilerlemesini gosteren 4-asamali progress sirit.
// Birim Amiri -> IT -> Yonetici -> IK Tamamlama
import React from "react";
import { useI18n } from "../../providers/I18nProvider";

const STAGES = [
  { key: "supervisor", labelKey: "satRequest.status.pending_supervisor" },
  { key: "it", labelKey: "satRequest.status.pending_it" },
  { key: "manager", labelKey: "satRequest.status.pending_manager" },
  { key: "hr", labelKey: "satRequest.status.pending_hr" },
];

const STATUS_TO_KEY = {
  pending_supervisor: "supervisor",
  pending_it: "it",
  pending_manager: "manager",
  pending_hr: "hr",
};

// IT adimi opsiyonel oldugundan, needsItReview=false ise "it" asamasi
// siritan cikarilir ve ilerleme indexi kalan asamalara gore hesaplanir.
const RequestTimeline = ({ status, needsItReview = true }) => {
  const { t } = useI18n();
  const stages = needsItReview ? STAGES : STAGES.filter((s) => s.key !== "it");
  const terminalBad = status === "rejected" || status === "cancelled";
  let current;
  if (status === "completed") {
    current = stages.length;
  } else if (terminalBad) {
    current = -1;
  } else {
    const key = STATUS_TO_KEY[status] || "supervisor";
    const idx = stages.findIndex((s) => s.key === key);
    current = idx < 0 ? 0 : idx;
  }

  return (
    <div className={`sat-timeline ${terminalBad ? "sat-timeline--bad" : ""}`}>
      {stages.map((s, idx) => {
        const done = !terminalBad && idx < current;
        const active = !terminalBad && idx === current;
        const cls = [
          "sat-timeline__step",
          done && "is-done",
          active && "is-active",
        ]
          .filter(Boolean)
          .join(" ");
        return (
          <React.Fragment key={s.key}>
            <div className={cls}>
              <span className="sat-timeline__dot">{idx + 1}</span>
              <span className="sat-timeline__label">{t(s.labelKey)}</span>
            </div>
            {idx < stages.length - 1 && <div className="sat-timeline__bar" />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default RequestTimeline;
